import ArrowBackIcon from "@mui/icons-material/ArrowBackRounded";
import { Container, IconButton } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import { pageRoutes } from "../../../../../routes";
import GeneralPageHeader from "../../../../common/GeneralPageHeader";
import WorkbookDetailsContainer from "../../common/WorkbookDetailsContainer";
import WorkbookFilters from "../../common/WorkbookFilters";
import useWorkbookRunPolling from "../../hooks/useWorkbookRunPolling";
import WorkbookRunDetailsPageTitle from "./WorkbookRunDetailsPageTitle";
import WorkbookRunDetailsReports from "./WorkbookRunDetailsReports";

const WorkbookRunDetailsPage = () => {
  usePageTitle("Workbook Run");
  const navigate = useNavigate();
  const { runId } = useParams();

  const { workbookRun, setWorkbookRun, fetchError } = useWorkbookRunPolling(defined(runId));

  const handleBack = () => {
    navigate(`../../${pageRoutes.workbookRunner}?tab=runs`);
  };

  if (fetchError) {
    return <DataLoadingFailed title="Failed to load workbook run" />;
  }

  if (workbookRun === undefined) {
    return <InlineLoader text="Loading workbook run..." />;
  }

  return (
    <>
      <GeneralPageHeader
        BackButton={
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        }
        TitleComponent={<WorkbookRunDetailsPageTitle name={workbookRun.name} status={workbookRun.status} />}
      />
      <Container maxWidth="xl" disableGutters sx={{ height: "100%", display: "flex" }}>
        <WorkbookRunDetailsReports workbookRun={workbookRun} setWorkbookRun={setWorkbookRun} />
        <WorkbookDetailsContainer>
          <WorkbookFilters workbookFilters={workbookRun.workbookFilters} />
        </WorkbookDetailsContainer>
      </Container>
    </>
  );
};

export default WorkbookRunDetailsPage;
